import type { JSX } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";
import { useIslandPortalContainer } from "@frontend/contexts";

import type { AlertDialogPortalProps } from "./AlertDialog.types";

export function AlertDialogPortal({
  children,
  ...props
}: AlertDialogPortalProps): JSX.Element {
  const container = useIslandPortalContainer();

  return (
    <BaseAlertDialog.Portal
      data-slot="alert-dialog-portal"
      container={container}
      {...props}
    >
      {children}
    </BaseAlertDialog.Portal>
  );
}
